import { env } from '@/constant';

/**
 * LocalStorage 自营升级用户信息 key 值
 * 暂时以设备为维度存储该值，避免统一用户不同 token 的情况
 */
export const upgradeUserInfosKey = `Hellobike_AppFinanceH5Web_UpgradeInfos_${env}`;

export interface UpgradeUserInfoType {
  needToast: boolean;
}
